<script>
    import VueContentLoading from 'vue-content-loading';

    export default {
        components: {
            VueContentLoading,
        },
    };
</script>

<template>
    <vue-content-loading :width="300" :height="300">
        <circle cx="150" cy="135" r="130" />
        <rect x="0" y="275" rx="4" ry="4" width="80" height="15" />
        <rect x="100" y="275" rx="4" ry="4" width="80" height="15" />
        <rect x="200" y="275" rx="4" ry="4" width="80" height="15" />
    </vue-content-loading>
</template>
